export default {
  name: 'message-detail',
  created () {
    this.search()
  },
  data () {
    return {
      searchCallbackFlag: false,
      replyMessage: ''
    }
  },
  computed: {
    messageDetail() {
      return this.$store.getters.messageDetail
    },
    isShopMaster () {
      return window.localStorage.getItem('is_shop_master') === '1'
    },
    isOfficer() {
      return window.localStorage.getItem('is_officer') === '1'
    },
    isHarassment() {
      return window.localStorage.getItem('is_harassment') === '1'
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    timeStamp() {
      var d = new Date()
      var year  = d.getFullYear()
      var month = d.getMonth() + 1
      var day   = d.getDate()
      var hour  = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min   = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec   = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year +''+ month +''+ day +''+ hour +''+ min +''+ sec
    }
  },
  methods: {
    goMessageList: function () {
      this.$router.push({ path: '/message_list'})
    },
    search: function () {
      console.log('isShopMaster:', this.isShopMaster)
      if (this.isShopMaster) {
        var self = this
        var data = {
          'message_id': self.$route.params.id
        }
        var callback = function () {
          self.searchCallbackFlag = true
        }
        this.$store.dispatch('GET_MESSAGEMANAGER_DETAIL', { data: data, callback: callback })
        this.$store.dispatch('UPDATE_MESSAGEMANAGER_READ', { data: data })
      }
      if (this.isOfficer) {
        var self = this
        var data = {
          'message_id': self.$route.params.id
        }
        var callback = function () {
          self.searchCallbackFlag = true
        }
        this.$store.dispatch('GET_MESSAGEOFFICER_DETAIL', { data: data, callback: callback })
        this.$store.dispatch('UPDATE_MESSAGEOFFICER_READ', { data: data })
      }
      if (this.isHarassment) {
        var self = this
        var data = {
          'message_id': self.$route.params.id
        }
        var callback = function () {
          self.searchCallbackFlag = true
        }
        this.$store.dispatch('GET_MESSAGEHARASSMENT_DETAIL', { data: data, callback: callback })
        this.$store.dispatch('UPDATE_MESSAGEHARASSMENT_READ', { data: data })
      }
    },
    getMessageContent: function(messageContent) {
      var stringMaxLength = 73
      if (messageContent.length > stringMaxLength) {
        messageContent = messageContent.substring(0, stringMaxLength)
      }
      return messageContent ? messageContent.replace(/\r?\n/g, '<br>') + '<br><span>…もっと見る</span>': ''
    },
    unread: function (alreadyRead) {
      if (alreadyRead == 0) {
        return '-unread'
      } else {
        return ''
      }
    },
    content: function (word) {
      word = word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')
      var re_url = /((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?)/gi;
      word = word.replace(re_url, '<a href="$1" target="_blank" style="color: #337ab7">$1</a>').replace(/\r?\n/g, '<br>')
      return word
    },
    sendReply: function () {
      if (!this.replyMessage.trim()) {
        alert('返信内容を入力してください')
        return
      }
      
      if (!confirm('返信は1度しかできません。送信して良いですか？')) {
        return
      }
      
      var self = this
      var data = {
        'message_id': self.$route.params.id,
        'reply_message': self.replyMessage
      }
      var callback = function () {
        alert('返信を送信しました')
        self.$router.push({ path: '/message_list'})
      }
      this.$store.dispatch('POST_MESSAGEMANAGER_REPLY', { data: data, callback: callback })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/message-detail.js